import {Component, computed, input} from '@angular/core';
import {FloatLabel} from 'primeng/floatlabel';
import {DatePicker} from 'primeng/datepicker';
import {InputMaskDirective} from 'primeng/inputmask';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {MessageModule} from 'primeng/message';

@Component({
  selector: 'elcia-date-picker',
  imports: [
    FloatLabel,
    DatePicker,
    InputMaskDirective,
    ReactiveFormsModule,
    TranslateModule,
    MessageModule,
  ],
  templateUrl: './date-picker.html',
  styleUrl: './date-picker.scss',
})
export class ElciaDatePicker {
  label = input<string>();
  control = input.required<FormControl<Date | null>>();
  minDate = input<Date | null>();
  isRequired = computed(() => this.control().hasValidator(Validators.required));
}
